import React, { useState, useEffect } from 'react';
import './FloatingActions.css';

const FloatingActions = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when page is scrolled up to given distance
    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Set the top cordinate to 0
    // make scrolling smooth
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <div className="floating-actions">
            {/* WhatsApp Icon */}
            <a 
                href="https://wa.me/919382268887" 
                className="whatsapp-float" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Contact us on WhatsApp"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.246 2.248 3.484 5.232 3.484 8.412-.003 6.557-5.338 11.892-11.893 11.892-1.997-.001-3.951-.5-5.688-1.448l-6.309 1.656zm6.222-4.032c1.503.893 3.129 1.364 4.791 1.365 5.146.001 9.335-4.189 9.338-9.335.001-2.492-.97-4.835-2.735-6.601-1.765-1.767-4.108-2.74-6.602-2.741-5.145 0-9.336 4.191-9.338 9.337-.001 1.832.534 3.615 1.547 5.134l-1.015 3.704 3.814-.999zm11.231-6.732c-.301-.15-1.777-.872-2.046-.967-.27-.095-.466-.142-.663.15-.197.293-.761.967-.933 1.166-.172.199-.344.224-.645.074-.301-.15-1.27-.468-2.42-1.493-.895-.798-1.499-1.783-1.675-2.083-.176-.3-.02-.462.131-.611.135-.134.301-.35.451-.525.15-.175.199-.3.3-.5.101-.2.05-.375-.025-.525-.075-.15-.663-1.597-.909-2.193-.242-.581-.487-.502-.663-.51-.171-.007-.369-.009-.567-.009-.197 0-.517.074-.787.375-.27.301-1.029 1.009-1.029 2.459 0 1.45 1.055 2.85 1.202 3.05.148.199 2.076 3.17 5.03 4.453.703.305 1.252.487 1.681.623.707.225 1.35.193 1.859.117.568-.085 1.777-.726 2.026-1.426.25-.7.25-1.3.175-1.426-.076-.126-.271-.199-.572-.349z"/>
                </svg>
            </a>

            {/* Back to Top Icon */}
            <button 
                className={`scroll-top-float ${isVisible ? 'show' : ''}`} 
                onClick={scrollToTop}
                aria-label="Scroll to top"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
            </button>
        </div>
    );
};

export default FloatingActions;
